export enum GROUP_TYPE {
	PEASY_GROUP = 50,
}

export enum GROUP_ROLE {
	MEMBER = 'member',
	FOLLOWER = 'follower',
	ADMIN = 'admin',
	OWNER = 'owner',
}